export default __webpack_public_path__ + "static/media/36I-114281_-20902_0.9a7cf578.jpg";